import { SyncingStateDisplayData } from './models';

export const config: { [id: string]: SyncingStateDisplayData } = {
  Started: {
    title: 'Preparing for syncing... ',
    note: 'To give you the best search experience we need to sync your data. \n It may take few minutes and your page will be updated automatically.',
  },
  Failed: {
    title: 'Sync failed',
    subtitle: 'We’re sorry. we couldn’t sync your account',
    note: 'We will try again in few minutes',
  },
  Succeeded: {
    title: '0 Resources synced',
    subtitle: 'There are no resources available for this account',
  },
};
